import {
    Paper
} from "@mui/material";
import { compose } from "@reduxjs/toolkit";
import dayjs from "dayjs";
import React from "react";
import { connect } from "react-redux";
import LandingScreenHeader from "../../components/Comman/LandingScreenHeader";
import DynamicFormForDocumentUpload from "../../components/dynamicscreens/DynamicFormForDocumentUpload";
import { withRouter } from "../../components/withRouter";
import endpoint from "../../config/endpoints";
import { noInternetMsg, saveFailedMsg, savemsg, saveWarningMsg, serverMsg, updateData } from "../../config/messageconstant";
import { googleAddressUrl, googleApiKey } from "../../config/Url";
import { OutletEnquiryJson } from "../../DynamicFormsJson/MastersJSON/outletEnquiry";
import { getBeatListByUserType, getTownDistributorSalesTeamByBeatId } from "../../Slice/beat.slice";
import { getChannel, getSubChannelByChannel } from "../../Slice/channel.slice";
import { getOutletTypeBySubChannel } from "../../Slice/outletType.slice";
import { apiGet, apiPost, apiPostForImage } from "../../utils/api_service";
import { getCurrentDate } from "../../utils/dateFormat";
import LocationRow from "../../utils/locationRow";
import { showLoador, showNotification } from "../Landing/Landing.slice";
import GoogleMapForAreaExploration from "../Request For Distributor/GoogleMapForAreaExploration";
import { getSalesTeamByStateForEnquiry, getBelowSalesTeamBySalesTeamId } from "../../Slice/salesExecutive.slice";
import { getAllStateOptimized } from "../../Slice/enquiryMaster.slice";
class OutletEnquiryForm extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            showLocation: false,
            latitude: "",
            longitude: "",
            locationValue: "1",
            address: "",
            openMap: false,
            addedDate: getCurrentDate(),
            editData: {},
            isShowAdvancedEnquirymaster: 0,
            dynamicMasterData: {
                outletTypeDetail: this.props.outletTypeList?.outletType,
                beatDetail: this.props.beatList?.beatByUserType,
                subChannelDetail: this.props.subChannelList?.subChannel,
                stockHolderDetail: this.props.beatList?.outletEnquiryBeat?.stockStakeHolders,
                channelDetail: this.props.channelList?.channel,
                potentialDetail: this.props.beatList?.outletEnquiryBeat?.potentialRates,
                platformDetail: this.props.beatList?.outletEnquiryBeat?.enquiryPlatforms,
            },
        };
    }

    componentWillReceiveProps(nextProps) {

        const { isShowAdvancedEnquirymaster } = this.state;

        if (this.props.beatList !== nextProps.beatList) {
            const nextBeat = nextProps.beatList;
            const prevBeat = this.props.beatList;

            const updatedData = {};

            if (prevBeat?.beatByUserType !== nextBeat?.beatByUserType) {
                updatedData.beatDetail = nextBeat?.beatByUserType;
            }

            if (prevBeat?.outletEnquiryBeat?.stockStakeHolders !== nextBeat?.outletEnquiryBeat?.stockStakeHolders) {
                updatedData.stockHolderDetail = nextBeat?.outletEnquiryBeat?.stockStakeHolders ?? [];
            }


            if (isShowAdvancedEnquirymaster == 0 && prevBeat?.outletEnquiryBeat?.salesTeams !== nextBeat?.outletEnquiryBeat?.salesTeams) {
                updatedData.salesTeamDetail = nextBeat?.outletEnquiryBeat?.salesTeams ?? [];
            }

            if (prevBeat?.outletEnquiryBeat?.potentialRates !== nextBeat?.outletEnquiryBeat?.potentialRates) {
                updatedData.potentialDetail = nextBeat?.outletEnquiryBeat?.potentialRates ?? [];
            }

            if (prevBeat?.outletEnquiryBeat?.enquiryPlatforms !== nextBeat?.outletEnquiryBeat?.enquiryPlatforms) {
                updatedData.platformDetail = nextBeat?.outletEnquiryBeat?.enquiryPlatforms ?? [];
            }

            if (prevBeat?.outletEnquiryBeat?.states !== nextBeat?.outletEnquiryBeat?.states) {
                updatedData.stateDetail = nextBeat?.outletEnquiryBeat?.states ?? [];
            }

            if (Object.keys(updatedData).length > 0) {
                this.setState({
                    dynamicMasterData: {
                        ...this.state.dynamicMasterData,
                        ...updatedData,
                    },
                });
            }
        }

        if (this.props.subChannelList !== nextProps.subChannelList) {
            if (this.props.subChannelList?.subChannel !== nextProps.subChannelList?.subChannel) {
                this.setState({
                    dynamicMasterData: {
                        ...this.state.dynamicMasterData,
                        subChannelDetail: nextProps.subChannelList?.subChannel,
                    },
                });
            }
        }

        if (isShowAdvancedEnquirymaster == 1 && this.props.salesTeamList !== nextProps.salesTeamList) {
            if (this.props.salesTeamList?.salesExecutive !== nextProps.salesTeamList?.salesExecutive) {
                this.setState({
                    dynamicMasterData: {
                        ...this.state.dynamicMasterData,
                        salesTeamDetail: nextProps.salesTeamList?.salesExecutive,
                    },
                });
            }
        }

        if (this.props.channelList !== nextProps.channelList) {
            if (this.props.channelList?.channel !== nextProps.channelList?.channel) {
                this.setState({
                    dynamicMasterData: {
                        ...this.state.dynamicMasterData,
                        channelDetail: nextProps.channelList?.channel,
                    },
                });
            }
        }

        if (this.props.outletTypeList !== nextProps.outletTypeList) {
            if (this.props.outletTypeList?.outletType !== nextProps.outletTypeList?.outletType) {
                this.setState({
                    dynamicMasterData: {
                        ...this.state.dynamicMasterData,
                        outletTypeDetail: nextProps.outletTypeList?.outletType,
                    },
                });
            }
        }
    }

    getCurrentLocationData = () => {
        const success = (position) => {
            const latitude = position.coords.latitude;
            const longitude = position.coords.longitude;
            this.setAddressData(latitude, longitude);
            this.setState({
                latitude: latitude,
                longitude: longitude,
            });
            return { latitude: latitude, longitude: longitude };
        };

        const error = () => {
            console.log("Unable to retrieve your location");
            return "";
        };

        navigator.geolocation.getCurrentPosition(success, error);
    };

    async componentDidMount() {
        const {
            getBeatListByUserType,
            getChannel,
            showLoador,
            showNotification,
            getAllStateOptimized,
        } = this.props;

        if (navigator.onLine) {

            const isShowAdvancedEnquirymaster = localStorage.getItem("isShowAdvanceEnquiryMaster") ?? 0

            this.setState({ isShowAdvancedEnquirymaster });


            if (isShowAdvancedEnquirymaster == 1) {
                showLoador({ loador: true });
                await getAllStateOptimized().then(({ response, success }) => {
                    if (!success) {
                        showNotification({ msg: serverMsg, severity: "error" });
                    } else {
                        this.setState({
                            dynamicMasterData: {
                                ...this.state.dynamicMasterData,
                                stateDetail: response ?? [],
                            },
                        });

                    }
                });
                showLoador({ loador: false });

            } else {

                if (this.props.params.id == undefined) {
                    this.setState({
                        showLocation: true,
                    });
                    this.getCurrentLocationData();
                }

                showLoador({ loador: true });
                await getBeatListByUserType().then(({ success }) => {
                    showLoador({ loador: false });
                    if (!success) {
                        showNotification({ msg: serverMsg, severity: "error" });
                    }
                });

                showLoador({ loador: true });
                await getChannel().then(({ success }) => {
                    showLoador({ loador: false });
                    if (!success) {
                        showNotification({ msg: serverMsg, severity: "error" });
                    }
                });
            }
        } else {
            this.props.showNotification({ msg: noInternetMsg, severity: "error" });
        }
    }

    getListById = async (data) => {

        const {
            getSubChannelByChannel,
            getTownDistributorSalesTeamByBeatId,
            getOutletTypeBySubChannel,
            getSalesTeamByStateForEnquiry,
            getBelowSalesTeamBySalesTeamId,
            showLoador,
            showNotification,
        } = this.props;
        if (navigator.onLine) {
            if (data.channelId && data.channelId != "") {
                showLoador({ loador: true });
                await getSubChannelByChannel({
                    channelId: data.channelId,
                }).then(({ success }) => {
                    showLoador({ loador: false });
                    if (!success) {
                        showNotification({ msg: serverMsg, severity: "error" });
                    }
                });
            }

            if (data.subChannelId && data.subChannelId != "") {
                showLoador({ loador: true });
                await getOutletTypeBySubChannel({
                    subChannelId: data.subChannelId,
                }).then(({ success }) => {
                    showLoador({ loador: false });
                    if (!success) {
                        showNotification({ msg: serverMsg, severity: "error" });
                    }
                });
            }

            if (data.beatId && data.beatId != "") {
                showLoador({ loador: true });
                await getTownDistributorSalesTeamByBeatId({ beatId: data.beatId }).then(({ success }) => {
                    showLoador({ loador: false });
                    if (!success) {
                        showNotification({ msg: serverMsg, severity: "error" });
                    }
                });

            }

            if (data.stateId && data.stateId != "") {
                showLoador({ loador: true });
                await getSalesTeamByStateForEnquiry({
                    stateId: data.stateId,
                }).then(({ success }) => {
                    showLoador({ loador: false });
                    if (!success) {
                        showNotification({ msg: serverMsg, severity: "error" });
                    }
                });
            }

            if (data.enquiryAllocatedId && data.enquiryAllocatedId != "") {
                showLoador({ loador: true });
                await getBelowSalesTeamBySalesTeamId({
                    salesTeamId: data.enquiryAllocatedId,
                }).then(({ response, success }) => {
                    showLoador({ loador: false });
                    if (!success) {
                        showNotification({ msg: serverMsg, severity: "error" });
                    } else {
                        this.setState({
                            dynamicMasterData: {
                                ...this.state.dynamicMasterData,
                                enquiryForwardedToDetails: response ?? [],
                            },
                        });
                    }
                });
            }
        } else {
            showNotification({
                msg: noInternetMsg,
                severity: "error",
            });
        }
    }


    getDataById = async (id) => {
        const { showLoador, showNotification } =
            this.props;

        if (navigator.onLine) {
            showLoador({ loador: true });
            const response = await apiGet({
                url: OutletEnquiryJson.apiBaseURL + "/" + this.props.params.id,
            }).then(async ({ data, success }) => {
                if (success) {
                    let rowData = data.data;

                    this.setState({
                        latitude: rowData.latitude ?? "-",
                        longitude: rowData.longitude ?? "-",
                        address: rowData.address ?? "-",
                        addedDate: rowData.addedDate ?? getCurrentDate(),
                        editData: rowData,
                    });


                    return { response: rowData, success };
                } else {
                    showNotification({ msg: serverMsg, severity: "error" });
                }

                return { response: {}, success: false };
            });
            return response;
        } else {
            this.props.showNotification({ msg: noInternetMsg, severity: "error" });
        }
        showLoador({ loador: false });
    };

    getLocation = (latitude, longitude) => {
        this.setAddressData(latitude, longitude);

        this.setState({
            openMap: false,
            latitude: latitude,
            longitude: longitude,
        });
    };

    onCancel = () => {
        this.props.navigate(-1);
    };

    onSaveLocation = () => {
        this.setState({
            openMap: true,
        });
    };

    onRadioChange = (e) => {
        const { value } = e.target;
        this.setState({
            locationValue: value,
        });
        if (value == 1) {
            this.getCurrentLocationData();
        }
    };

    getLocationData = () => {
        let locationData = "";
        const { latitude, longitude } = this.state;
        if (
            this.props.params.id == undefined &&
            latitude == "" &&
            longitude == ""
        ) {
            this.props.showNotification({
                msg: "Please allow location",
                severity: "error",
            });
        } else if (latitude != "" && longitude != "") {
            locationData = {
                latitude: this.state.latitude,
                longitude: this.state.longitude,
                address: this.state.address,
            };
        }

        return locationData;
    };

    changeLocation = () => {
        const { latitude, longitude } = this.state;
        if (latitude == "" && longitude == "") {
            this.getCurrentLocationData();
        }
        this.setState({
            showLocation: true,
        });
    };

    setDataToForm = (data) => {
        const { latitude, longitude } = this.state;
        if (latitude == "" && longitude == "") {
            this.setState({
                latitude: data.latitude,
                longitude: data.longitude,
                address: data.address,
            });
        }
    };

    // Fill Sales Person Contact No from selected Assign To
    getDataForDisabled = (value) => {
        const { dynamicMasterData } = this.state;
        const salesTeamDetail = dynamicMasterData?.salesTeamDetail ?? [];
        let contactPersonNumber = "";
        for (let i = 0; i < salesTeamDetail.length; i++) {
            if (salesTeamDetail[i].id == value) {
                contactPersonNumber = salesTeamDetail[i].contactPersonNumber || "";
                break;
            }
        }
        return {
            salesPersonContactNo: contactPersonNumber,
        };
    };

    setAddressData = (latitude, longitude) => {
        const { showLoador } = this.props;
        if (googleApiKey !== null) {
            if (latitude !== null && longitude !== null) {
                showLoador({ loador: true });
                const apiUrl = `${googleAddressUrl}${latitude},${longitude}&key=${googleApiKey}`;

                fetch(apiUrl)
                    .then((response) => response.json())
                    .then((data) => {
                        showLoador({ loador: false });

                        if (data.status === "OK" && data.results.length !== 0) {
                            const fetchedAddress = data.results[0].formatted_address;
                            this.setState({ address: fetchedAddress });
                        } else {
                            console.error("Error:", data.status);
                        }
                    })
                    .catch((error) => {
                        showLoador({ loador: false });
                        console.error("Error:", error);
                    });
            }
        }
    };

    onSave = async (dataToSave, formData, isImageUpload, isToggle, fieldData) => {
        const { showNotification, showLoador, beatList } = this.props;
        const { editData, isShowAdvancedEnquirymaster } = this.state;

        if (navigator.onLine) {
            let finalDataToSave = {
                ...dataToSave,
                latitude: isShowAdvancedEnquirymaster == 1 ? null : this.state.latitude,
                longitude: isShowAdvancedEnquirymaster == 1 ? null : this.state.longitude,
                address: isShowAdvancedEnquirymaster == 1 ? dataToSave.address : this.state.address,
                townId: isShowAdvancedEnquirymaster == 1 ? null : beatList?.outletEnquiryBeat?.townId || "",
                townName: isShowAdvancedEnquirymaster == 1 ? null : beatList?.outletEnquiryBeat?.townName || "",
                addedDate: this.state.addedDate,
                flag: this.props.params.id ? 1 : 0,
                potentialRate: isShowAdvancedEnquirymaster == 1 ? null :
                    dataToSave?.potentialRate == 100 ? 0 : dataToSave?.potentialRate ?? 0,
            };

            if (editData && Object.keys(editData).length > 0) {
                finalDataToSave = {
                    ...finalDataToSave,
                    id: editData?.id ?? "",
                    beatName: editData?.beatName ?? "",
                    channelName: editData?.channelName ?? "",
                    subChannelName: editData?.subChannelName ?? "",
                    outletTypeName: editData?.outletTypeName ?? "",
                    distributorName: editData?.distributorName ?? "",
                    image: editData?.image ?? null,
                    enquiryRaisedPlatformName: editData?.enquiryRaisedPlatformName ?? "",
                    enquiryAllocatedName: editData?.enquiryAllocatedName ?? "",
                    enquiryAllocatedTypeId: editData?.enquiryAllocatedTypeId ?? "",
                    enquiryAllocatedTypeName: editData?.enquiryAllocatedTypeName ?? "",
                    gstNumber: editData?.gstNumber ?? "",
                    gstType: editData?.gstType ?? 0,
                    insertDateTime: editData?.insertDateTime ?? "",
                    insertedUserId: editData?.insertedUserId ?? "",
                    isActive: editData?.isActive ?? 1,
                    isActiveValue: editData?.isActiveValue ?? "Active",
                    isConverted: editData?.isConverted ?? 0,
                    isConvertedValue: editData?.isConvertedValue ?? "",
                    isVisited: editData?.isVisit ?? 0,
                    isVisit: editData?.isVisit ?? 0,
                    isVisitedValue: editData?.isVisitedValue ?? "",
                    outletUniqueCode: editData?.outletUniqueCode ?? "",
                    allocatedDateTime: editData?.allocatedDateTime ?? null,
                    allocatedPersonRemark: editData?.allocatedPersonRemark ?? null,
                };
            }

            swal({
                title: "Are you sure?",
                text: this.props.params.id ? updateData : saveWarningMsg,
                icon: "warning",
                buttons: true,
                dangerMode: true,
            }).then(async (willDelete) => {
                if (willDelete) {
                    let fileNameData = "";

                    if (
                        isImageUpload &&
                        fieldData.image &&
                        fieldData.image !== "" &&
                        fieldData.image !== null &&
                        fieldData.image.name !== null
                    ) {

                        fileNameData =
                            dayjs(fieldData.image.lastModifiedDate).format("hh:mm:ss") +
                            fieldData.image.name;

                        const imageFormData = new FormData();
                        imageFormData.append("file", fieldData.image);
                        imageFormData.append("imageName", fileNameData);

                        showLoador({ loador: true });
                        await apiPostForImage({
                            url: endpoint.uploadImage,
                            postBody: imageFormData,
                        }).then(({ data, success }) => {
                            if (!success) {
                                showNotification({ msg: serverMsg, severity: "error" });
                            }
                        });
                        showLoador({ loador: false });
                    }

                    //reassign instead of redeclaring with `let`
                    finalDataToSave = {
                        ...finalDataToSave,
                        image: isImageUpload
                            ? fileNameData !== ""
                                ? fileNameData
                                : null
                            : finalDataToSave.image ?? null,
                    };

                    showLoador({ loador: true });
                    await apiPost({
                        url: endpoint.enquiryMaster + "/save-or-update-for-web",
                        postBody: finalDataToSave,
                    }).then(({ data, success }) => {
                        if (success) {
                            showNotification({
                                msg: data?.data?.message || (this.props.params.id ? updateData : savemsg),
                                severity: "success",
                            });
                            this.props.navigate(-1);
                        } else {
                            showNotification({ msg: saveFailedMsg, severity: "error" });
                        }
                    });
                    showLoador({ loador: false });
                }
            });
        } else {
            showNotification({ msg: noInternetMsg, severity: "error" });
        }
    };

    onCloseMap = () => {
        this.setState({
            openMap: false,
        });
    };

    render() {
        const {
            dynamicMasterData,
            openMap,
            latitude,
            longitude,
            showLocation,
            locationValue,
            address,
            isShowAdvancedEnquirymaster,
        } = this.state;

        return (
            <>
                {!openMap ? (
                    <>
                        <Paper
                            sx={{
                                p: 2,
                                pt: 2,
                                borderRadius: 2,
                            }}
                            elevation={0}
                        >

                            <LandingScreenHeader
                                screenTitle={OutletEnquiryJson.screenTitle}
                                showTable={false}
                                showBackButton={true}
                                showAddButton={false}
                                onCancel={this.onCancel}
                            />
                            {isShowAdvancedEnquirymaster == 0 && (
                                <LocationRow
                                    id={this.props.params.id}
                                    showLocation={showLocation}
                                    locationValue={locationValue}
                                    latitude={latitude}
                                    longitude={longitude}
                                    onChangeLocation={this.changeLocation}
                                    onRadioChange={this.onRadioChange}
                                    onSaveLocation={this.onSaveLocation}
                                    address={address}
                                    addressTitle="Address"
                                />
                            )}

                            <DynamicFormForDocumentUpload
                                getDataForm={true}
                                setDataToForm={this.setDataToForm}
                                getExtraData={false}
                                getData={this.getLocationData}
                                getByIdApi={this.getDataById}
                                callGetByIdApi={false}
                                getListById={this.getListById}
                                getDataForDisabled={this.getDataForDisabled}
                                padding={false}
                                paddingTop={false}
                                showBackToList={false}
                                formPath={OutletEnquiryJson.formPath}
                                fieldMeta={isShowAdvancedEnquirymaster == 1 ? OutletEnquiryJson.fieldMetaForAdvancedEnquiryMaster : OutletEnquiryJson.fieldMeta}
                                dynamicMasterData={dynamicMasterData}
                                apiBaseURL={OutletEnquiryJson.apiBaseURL}
                                onSave={this.onSave}
                                directSave={false}
                                isDataClearAfterSave={false}
                                isLog={true}
                                type={0}
                                showSaveNextBtn={false}
                                saveText={this.props.params.id ? "Update" : "Save"}
                            />
                        </Paper>
                    </>
                ) : (
                    <Paper elevation={0}>
                        <GoogleMapForAreaExploration
                            getLocation={this.getLocation}
                            setLocation={{
                                latitude: latitude,
                                longitude: longitude,
                            }}
                            address={address}
                            closeMap={this.onCloseMap}

                        />
                    </Paper>
                )}
            </>
        );
    }
}
const mapStateToProps = (state) => ({
    outletTypeList: state.outletType,
    beatList: state.beat,
    subChannelList: state.channel,
    stockHolderList: state.stackholder,
    channelList: state.channel,
    salesTeamList: state.salesExecutive,
});
const mapDispatchToProps = {
    getBeatListByUserType,
    showLoador,
    showNotification,
    getSubChannelByChannel,
    getTownDistributorSalesTeamByBeatId,
    getChannel,
    getOutletTypeBySubChannel,
    getSalesTeamByStateForEnquiry,
    getBelowSalesTeamBySalesTeamId,
    getAllStateOptimized,
};
export default compose(
    withRouter,
    connect(mapStateToProps, mapDispatchToProps)
)(OutletEnquiryForm);
